import * as THREE from "three";
import data from "../../data/art";
import vertex from "./shader/vertex.glsl";
import fragment from "./shader/fragment.glsl";

function lerp(start, end, t) {
  return start * (1 - t) + end * t;
}

let targetX = 0;
let targetY = 0;

let images = [];
for (let i = 0; i < data.length; i++)
  images.push(new THREE.TextureLoader().load(data[i].img[0]));

export default class WebGL {
  constructor() {
    this.container = document.querySelector("#main");
    this.links = [...document.querySelectorAll(".artists_grid .artist_item")];
    this.scene = new THREE.Scene();
    this.perspective = 1000;
    // this.sizes = new THREE.Vector2(0,0);
    this.activeLinkId = null;
    this.offset = new THREE.Vector2(0, 0); // Positions of mesh on screen. Will be updated below.
    this.uniforms = {
      uTexture: { value: images[0] },
      uAlpha: { value: 0.0 },
      uOffset: { value: new THREE.Vector2(0.0, 0.0) },
    };
    this.links.forEach((link, idx) => {
      link.addEventListener("mouseenter", () => {
        this.uniforms.uTexture.value = images[idx];
        this.activeLinkId = idx;
      });

      link.addEventListener("mouseleave", () => {
        this.uniforms.uAlpha.value = lerp(this.uniforms.uAlpha.value, 0.0, 0.1);
        this.activeLinkId = null;
      });
    });
    this.addEventListeners(this.container);
    this.setUpCamera();
    this.onMouseMove();
    this.createMesh();
    this.render();
  }

  get viewport() {
    let width = this.container.offsetWidth;
    let height = this.container.offsetHeight;
    let aspectRatio = width / height;

    return {
      width,
      height,
      aspectRatio,
    };
  }

  addEventListeners(element) {
    element.addEventListener("mouseenter", () => {
      this.linkHovered = true;
    });
    element.addEventListener("mouseleave", () => {
      this.linkHovered = false;
    });
  }

  setUpCamera() {
    window.addEventListener("resize", this.onWindowResize.bind(this));

    let fov =
      (180 * (2 * Math.atan(this.viewport.height / 2 / this.perspective))) /
      Math.PI;
    this.camera = new THREE.PerspectiveCamera(
      fov,
      this.viewport.aspectRatio,
      0.1,
      1000
    );
    this.camera.position.set(0, 0, this.perspective);

    this.renderer = new THREE.WebGL1Renderer({ antialias: true, alpha: true });
    this.renderer.setSize(this.viewport.width, this.viewport.height);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.container.appendChild(this.renderer.domElement);
  }

  createMesh() {
    this.geometry = new THREE.PlaneGeometry(1, 1, 20, 20);
    this.material = new THREE.ShaderMaterial({
      uniforms: this.uniforms,
      vertexShader: vertex,
      fragmentShader: fragment,
      transparent: true,
      // wireframe: true,
      // side: THREE.DoubleSide
    });
    this.mesh = new THREE.Mesh(this.geometry, this.material);
    this.mesh.scale.set(0, 0, 1);
    this.mesh.position.set(this.offset.x, this.offset.y, 0);

    this.scene.add(this.mesh);
  }

  onWindowResize() {
    this.camera.aspect = this.viewport.aspectRatio;
    this.camera.fov =
      (180 * (2 * Math.atan(this.viewport.height / 2 / this.perspective))) /
      Math.PI;
    this.renderer.setSize(this.viewport.width, this.viewport.height);
    this.camera.updateProjectionMatrix();
  }

  onMouseMove() {
    document.addEventListener("mousemove", (e) => {
      targetX = e.clientX;
      targetY = e.clientY - this.container.getBoundingClientRect().top;
    });
    document.addEventListener("touchmove", (e) => {
      targetX = e.touches[0].clientX;
      targetY =
        e.touches[0].clientY - this.container.getBoundingClientRect().top;
    });
  }

  render() {
    this.offset.x = lerp(this.offset.x, targetX, 0.4);
    this.offset.y = lerp(this.offset.y, targetY, 0.4);
    this.uniforms.uOffset.value.set(
      (targetX - this.offset.x) * 0.0008,
      -(targetY - this.offset.y) * 0.0008
    );

    if (window.innerWidth < 767) {
      var meshWidth = 320;
    } else {
      var meshWidth = 600;
    }

    if (this.activeLinkId !== null) {
      this.mesh.scale.set(
        meshWidth,
        (meshWidth * images[this.activeLinkId].image.height) /
          images[this.activeLinkId].image.width,
        1
      );
    } else {
      this.mesh.scale.set(0, 0, 1);
    }

    this.mesh.position.set(
      this.offset.x - this.viewport.width / 2,
      -this.offset.y + this.viewport.height / 2,
      0
    );

    // set uAlpha when list is hovered / unhovered
    this.linkHovered
      ? (this.uniforms.uAlpha.value = lerp(
          this.uniforms.uAlpha.value,
          1.0,
          0.1
        ))
      : (this.uniforms.uAlpha.value = lerp(
          this.uniforms.uAlpha.value,
          0.0,
          0.1
        ));

    this.renderer.render(this.scene, this.camera);
    window.requestAnimationFrame(this.render.bind(this));
  }
}
